import { Icon } from 'beek-design-system';
import styled from 'styled-components';

interface IRoute {
  title: string;
  url: string;
}

type BreadcrumbProps = {
  paths: IRoute[];
  marginTop?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginRight?: string;
};

type BreadcrumbsContainerProps = {
  marginTop?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginRight?: string;
};

const defaultProps = {
  marginTop: '0rem',
  marginBottom: '0rem',
  marginLeft: '0rem',
  marginRight: '0rem',
};

const BreadcrumbsMainContainer = styled.nav<BreadcrumbsContainerProps>`
  display: none;
  margin-top: ${(props): string | undefined => props.marginTop};
  margin-bottom: ${(props): string | undefined => props.marginBottom};
  margin-left: ${(props): string | undefined => props.marginLeft};
  margin-right: ${(props): string | undefined => props.marginRight};

  @media ${({ theme }): string => theme.devices.laptop} {
    display: flex;
    padding: 0rem;
  }
`;

const BreadcrumbContainer = styled.div`
  align-content: 'center';
  display: flex;
  &:not(:first-child) {
    margin-left: 0.583rem;
  }
`;
type LinkProps = {
  lastCrumb: boolean;
};

const Link = styled.a<LinkProps>`
  text-overflow: ellipsis;
  font-family: var(--primary-font);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1rem;
  margin-right: 0.583rem;
  color: ${(props): string =>
    props.lastCrumb ? 'var(--gray-70)' : 'var(--gray-100)'};
  cursor: ${(props): string => (props.lastCrumb ? 'default' : 'cursor')};
  ${(props): string => (props.lastCrumb ? 'pointer-events: none;' : '')}
  text-decoration: none;
  &:hover {
    text-decoration: ${(props): string =>
      props.lastCrumb ? 'none' : 'underline'};
  }
  &:active {
    text-decoration: ${(props): string =>
      props.lastCrumb ? 'none' : 'underline'};
    text-decoration-color: var(--gray-70);
    color: var(--gray-70);
  }
  &:visited {
    text-decoration: none;
    color: var(--gray-50);
  }
`;

const Breadcrumbs = (props: BreadcrumbProps): JSX.Element => {
  const { paths } = props;
  return (
    <BreadcrumbsMainContainer {...props}>
      {paths.map((path: { title: string; url: string }, i: number) => (
        <BreadcrumbContainer key={`breadcrumb: ${path.title}`}>
          <Link href={path.url} lastCrumb={i === paths.length - 1}>
            {path.title}
          </Link>
          {i === paths.length - 1 ? null : (
            <Icon colorVariant="beekBlue" name="arrow_right" />
          )}
        </BreadcrumbContainer>
      ))}
    </BreadcrumbsMainContainer>
  );
};

BreadcrumbsMainContainer.defaultProps = defaultProps;
Breadcrumbs.defaultProps = defaultProps;

export default Breadcrumbs;
